import styles from './ProcessSteps.module.css';

interface Step {
  number: string;
  title: string;
  description: string;
}

interface ProcessStepsProps {
  steps?: Step[];
}

const defaultSteps: Step[] = [
  {
    number: '01',
    title: 'Assess',
    description:
      'We audit your current data environment, identify fragmentation, and map your AI readiness against industry benchmarks.',
  },
  {
    number: '02',
    title: 'Architect',
    description:
      'We design your cloud-agnostic Medallion Lakehouse with embedded governance, quality frameworks, and Agentic AI pathways.',
  },
  {
    number: '03',
    title: 'Accelerate',
    description:
      'We deploy, automate, and operationalize your platform - enabling production-grade ML and measurable enterprise outcomes from day one.',
  },
];

export function ProcessSteps({ steps = defaultSteps }: ProcessStepsProps) {
  return (
    <div className={styles.wrapper} role="list">
      {steps.map((step, i) => (
        <div key={step.number} role="listitem" style={{ display: 'contents' }}>
          <div className={styles.step}>
            <div className={styles.number}>{step.number}</div>
            <h3 className={styles.title}>{step.title}</h3>
            <p className={styles.description}>{step.description}</p>
          </div>
          {i < steps.length - 1 && (
            <div className={styles.connector} aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10h12M12 6l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
